import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChartLine, faDownload, faFolderOpen, faList, faCalendarAlt, faAnchor, faGlobe, faFish } from '@fortawesome/free-solid-svg-icons';

const iconByHeader = (header) =>
{
    const label = header?.toLowerCase() || '';

    if (label.includes('descargas')) return faDownload;
    if (label.includes('proyectos')) return faFolderOpen;
    if (label.includes('tipos')) return faList;
    if (label.includes('años') || label.includes('anios')) return faCalendarAlt;
    if (label.includes('puertos')) return faAnchor;
    if (label.includes('regiones')) return faGlobe;
    if (label.includes('especies')) return faFish;

    return faChartLine;
};

const Estadisticas = ({ col, card, header, body, small }) =>
{
    return (
        <div className={col}>
            <div className={card}>
                <div className="card-header rounded-top-5 px-3 py-2 bg-white border-bottom d-flex align-items-center justify-content-between">
                    <span className="text-muted fs-6 mb-0">{header}</span>
                    <div className="rounded-3 p-2 d-flex align-items-center justify-content-center text-primary bg-primary bg-opacity-10" style={{ minWidth: '3rem', minHeight: '3rem' }}>
                        <FontAwesomeIcon icon={iconByHeader(header)} className="fs-5" />
                    </div>
                </div>
                <div className="card-body px-3 py-4 align-items-center text-center gap-3">
                    <div>
                        <h2 className="fw-bold text-primary mb-1">{body ? Number(body).toLocaleString('es-CL') : 0}</h2>
                        <p className="text-muted mb-0 small">{small}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Estadisticas;
